import { useSearchParams } from "@src/global_functions/hooks";
import { useEffect } from "react";
import { atom, useSetAtom, useAtomValue } from "jotai";

const savedSiteQueryParamsAtom = atom<string>();
/**
 * Saves query param string to an atom for use in Equipment breadcrumbs site crumb route
 */
export function useSaveSiteQueryParamsEffect() {
  const { getAllParams } = useSearchParams();
  const allSearchParams = getAllParams();
  const setSiteParams = useSetAtom(savedSiteQueryParamsAtom);

  useEffect(() => {
    setSiteParams(
      new URLSearchParams(
        Object.entries(allSearchParams).filter(
          (entry): entry is [string, string] => Boolean(entry[1])
        )
      ).toString()
    );
  }, [allSearchParams, setSiteParams]);
}

export function useSiteQueryParams() {
  const queryParams = useAtomValue(savedSiteQueryParamsAtom);
  return queryParams;
}
